
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M7.123 3.875V2.833a.834.834 0 011.667 0v1.042h2.294V2.833a.834.834 0 011.667 0v1.042h2.295V2.833a.834.834 0 011.666 0v1.042h.83a2.294 2.294 0 012.292 2.292v13.542A2.294 2.294 0 0117.542 22H6.292A2.294 2.294 0 014 19.709V6.167a2.294 2.294 0 012.292-2.292h.831zm5.21 4.792H8.168a.834.834 0 000 1.667h4.167a.834.834 0 000-1.667zm-5 7.5c0 .46.374.833.834.833H16.5a.834.834 0 000-1.666H8.167a.834.834 0 00-.834.833zm0-3.333c0 .46.374.833.834.833H16.5a.834.834 0 000-1.667H8.167a.834.834 0 00-.834.834z","fill":"#282E3E"}})])
          )
        }
      }
    